
export enum PerfMarks {
	LinkClick = 'cog-link-click',
	RouteStart = 'cog-route-start',
	PageReady = 'cog-page-ready',
}

export enum PerfMetrics {
	TimeToPageReady = 'TimeToPageReady'
}